import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface ICaseManagerResponse {
  email?: string;
  name: string;
}

export const getCaseManagerInfo = async (instance: AxiosInstance = axios) =>
  instance.get(Endpoints.CaseManager.GET_INFO);
